const MOBILE_BREAKPOINT = 375;
const TABLET_BREAKPOINT = 768;
const DESKTOP_BREAKPOINT = 1024;

/**
 * Proposed new breakpoints, used in the new Buy Flow.
 */
export const breakpoint = {
	mobile: MOBILE_BREAKPOINT,
	mobileEnd: TABLET_BREAKPOINT - 1,
	tablet: TABLET_BREAKPOINT,
	tabletEnd: DESKTOP_BREAKPOINT - 1,
	desktop: DESKTOP_BREAKPOINT,
};

export const mediaQuery = {
	mobile: `@media (max-width: ${breakpoint.mobileEnd}px)`,
	tablet: `@media (min-width: ${breakpoint.tablet}px) and (max-width: ${breakpoint.tabletEnd}px)`,
	tabletAndDown: `@media (max-width: ${breakpoint.tabletEnd}px)`,
	tabletAndUp: `@media (min-width: ${breakpoint.tablet}px)`,
	desktop: `@media (min-width: ${breakpoint.desktop}px)`,
};

/**
 * Existing device breakpoints (with hardcoded px suffixes). Used in the
 * existing marketing website. Where applicable, these have been mapped
 * to the proposed new simplified breakpoints.
 */
const device = {
	mobileM: `${breakpoint.mobile}px`,
	mobileXL: `${breakpoint.mobileEnd}px`,
	tablet: `${breakpoint.tablet}px`,
	tabletL: `${breakpoint.tabletEnd}px`,
	laptop: `${breakpoint.desktop}px`,

	laptopM: `1280px`,
	laptopL: `1440px`,
	desktopS: `1920px`,
	desktopM: `2559px`,
	desktop: `2560px`,
};

export const mobileMediaQuery = `@media (max-width: ${device.mobileXL})`;
export const tabletMediaQuery = `@media (min-width: ${device.tablet}) and (max-width: ${device.tabletL})`;
export const laptopMediaQuery = `@media (min-width: ${device.laptop}) and (max-width: ${device.desktopS})`;
export const desktopMediaQuery = `@media (min-width: ${device.desktopS}) and (max-width: ${device.desktopM})`;
export const desktopLMediaQuery = `@media (min-width: ${device.desktop})`;

export default device;
